<template>
    <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
        <div class="split-content-contact-block">
            <div :class="getStyle()">
                <div class="header">
                    <SmartLinkStandaloneElement :codename="typ.elements.icon.codename" v-if="data.icon">
                        <font-awesome class="icon fa-fw" :icon="data.icon" />
                    </SmartLinkStandaloneElement>
                    <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
                        <h2 class="title" v-if="data.title">
                            {{ data.title }}
                        </h2>
                    </SmartLinkStandaloneElement>
                </div>
                <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
                    <RichText :value="data.content" class="content" />
                </SmartLinkStandaloneElement>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { IContentItem } from '@kontent-ai/delivery-sdk';
import type { SplitContentContactBlockModel } from '~/models';
import { contentTypes } from '~/models';
const typ = contentTypes.contact_block;

const props = defineProps<{ model: SplitContentContactBlockModel }>();

const pageStore = usePageStore();

const data = {
    title: props.model.elements.title.value,
    content: props.model.elements.content.value,
    icon: props.model.elements.icon.value,
    styling: firstOrDefault(props.model.elements.styling.value)
}


function getStyle() {
    if (data.styling) {
        return `style-${data.styling.codename}`
    }

    return 'none';
}

</script>
